import { DATA_TYPES } from '@/models/dashboards/metrics.constants';

export const INPUT_TYPES = {
  NUMBER: 'NUMBER',
  DURATION: 'DURATION',
  PERCENTAGE: 'PERCENTAGE',
  MONETARY: 'MONETARY',
};

export const DURATION_OPTIONS = {
  HOURS: {
    label: 'Hours',
    formKey: 'hours',
    placeholder: 'Enter Number of Hours',
    shortHand: 'h',
    secondMultiplier: 60 * 60,
  },
  MINUTES: {
    label: 'Minutes',
    formKey: 'minutes',
    placeholder: 'Enter Number of Minutes',
    shortHand: 'm',
    secondMultiplier: 60,
  },
  SECONDS: {
    label: 'Seconds',
    formKey: 'seconds',
    placeholder: 'Enter Number of Seconds',
    shortHand: 's',
    secondMultiplier: 1,
  },
};

export const INPUT_TYPE_MAP = {
  [DATA_TYPES.SECONDS]: { placeholder: 'Select Time', icon: undefined },
  [DATA_TYPES.MILLISECONDS]: { placeholder: 'Select Time', icon: undefined },
  [DATA_TYPES.INTEGER]: { placeholder: 'Enter Value', icon: undefined },
  [DATA_TYPES.FLOAT]: { placeholder: 'Enter Value', icon: undefined },
  [DATA_TYPES.PERCENTAGE]: { placeholder: 'Enter Value', icon: 'percent' },
  [DATA_TYPES.MONETARY]: { placeholder: 'Enter Value', icon: 'currency-dollar' },
  default: { placeholder: 'Enter Value', icon: undefined },
};
